import { useCurrentStateAndParams } from "@uirouter/react";

import type { IAlertsRouteParams } from "../routes/routeParams";

export const useAlertsParams = () => {
    const {
        params: { key: activationId, duration, isDurationChanged, tab, alertsType, viewMode },
    } = useCurrentStateAndParams<IAlertsRouteParams>();

    return { activationId, alertsType, duration, isDurationChanged, tab, viewMode };
};
